import React, { useState } from 'react'
import api from '../services';
import { getUserFromToken } from '../Utils';
import { toast } from "react-toastify";
export default function ChangePassword() {
    const user = getUserFromToken();

    const [form, setForm] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        setMessage("");

        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.newPassword !== form.confirmPassword) {
            setMessage("New password and confirm password do not match");
            toast.success("New password and confirm password do not match!");
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("admin_id", user?.admin_id);
            formData.append("username", user?.email);
            formData.append("password", form.oldPassword);
            formData.append("new_password", form.newPassword);

            const response = await api(
                "post",
                "resetAdminPassword",
                formData,
                true
            );

            if (response.status === "success") {
                setForm({
                    oldPassword: "",
                    newPassword: "",
                    confirmPassword: ""
                });
                toast.success("Password changed successfully!");
            } else {
                toast.info(response.message);
            }

        } catch (error) {
            toast.error("Something went wrong");

        }

        setLoading(false);
    };
    const isPasswordMatch =
        form.newPassword &&
        form.confirmPassword &&
        form.newPassword === form.confirmPassword;

    const isFormValid =
        form.oldPassword &&
        form.newPassword &&
        form.confirmPassword &&
        isPasswordMatch;
    return (
        <>
            <form className="d-flex flex-column gap-3 my-3">
                <input
                    type="text"
                    name="oldPassword"
                    className="form-control"
                    placeholder="Old Password"
                    value={form.oldPassword}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="newPassword"
                    className="form-control"
                    placeholder="New Password"
                    value={form.newPassword}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="confirmPassword"
                    className="form-control"
                    placeholder="Confirm Password"
                    value={form.confirmPassword}
                    onChange={handleChange}
                    required
                />
                {form.confirmPassword && !isPasswordMatch && (
                    <div className="text-danger small">
                        New password and confirm password do not match
                    </div>
                )}
                <button
                    type="submit"
                    className="save-btn btn btn-dark btn-sm"
                    disabled={loading || !isFormValid}
                    onClick={handleSubmit}
                >
                    {loading ? "Updating..." : "Change Password"}
                </button>
            </form>
        </>
    )
}
